import { motion } from "framer-motion";

export const ProjectNarrative = ({ chapters, label }) => (
  <section data-testid="project-narrative" className="border-t border-white/10 py-16 md:py-24 lg:py-28">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{label}</p>
      <div className="mt-8 border-t border-white/10">
        {chapters.map((chapter, index) => (
          <motion.article
            key={chapter.title}
            data-testid={`project-narrative-chapter-${index + 1}`}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.55, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className="grid gap-5 border-b border-white/10 py-9 md:grid-cols-[minmax(180px,0.45fr)_minmax(0,1fr)] md:gap-12"
          >
            <h2 className="font-heading text-2xl font-medium tracking-tight text-white sm:text-3xl">
              {chapter.title}
            </h2>
            <div className="max-w-3xl space-y-5 text-base leading-relaxed text-zinc-400">
              {chapter.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);